import PropTypes from "prop-types";
import { useEffect, useRef, useState } from "react";
import { Button, Spinner } from "@aqar-app/aqar-design-system";
import style from "./iam.module.scss";
import useIam from "../../hooks/useIam";
import Input from "../input/input";

export default function IsBlocked({ desiredService }) {
  const ref = useRef(null);
  const { isBlackList, redirectToIam } = useIam();
  const [disabled, setDisabled] = useState(true);
  const [err, setErr] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const input = ref.current;
    if (!input) return undefined;

    function keyUp(e) {
      e.target.value = e.target.value.substring(0, 10);

      if (e.target.value.length > 9) {
        setDisabled(false);
        return e.preventDefault();
      }
      return setDisabled(true);
    }
    input.addEventListener("input", keyUp);
    return () => {
      input.removeEventListener("input", keyUp);
    };
  }, [ref]);
  return (
    <div className={style.IamModal}>
      <p>الرجاء ادخال رقم الهوية</p>
      <Input type="number" ref={ref} maxLength={10} placeholder="12XXXXXXX" />
      {err && <p className={style.err}>عفوا، الرجاء المحاولة خلال 12 ساعة</p>}
      <Button
        priority="primary"
        disabled={loading || err || disabled}
        onClick={() => {
          setLoading(true);
          isBlackList(ref.current.value).then((blackList) => {
            setLoading(false);
            if (!blackList) {
              return redirectToIam({
                desiredListing: desiredService,
              });
            }
            return setErr(true);
          });
        }}
      >
        {loading && <Spinner className={style.spinner} />}
        توثيق
      </Button>
    </div>
  );
}

export function getIamModalProps({ desiredService, ...props } = {}) {
  return {
    children: <IsBlocked desiredService={desiredService} />,
    title: "توثيق حسابك",
    footer: false,
    visible: true,
    closeBtn: true,
    closeOnClickOutside: false,
    bodyClassName: "p0",
    ...props,
  };
}

const props = {
  desiredService: PropTypes.string.isRequired,
};
IsBlocked.propTypes = props;
